import {EasyArg} from "./easy";
import {Arg} from "../arg";
import {CommandClause} from "../../command";
import {PsdkConst} from "../../types";

export class Raw extends EasyArg<Uint8Array> {

  private _mode: RawMode;
  private _text?: string;
  private _charset?: string;
  private _binary?: Uint8Array;
  private _newline: boolean = PsdkConst.DEF_ENABLED_NEWLINE;

  private constructor() {
    super();
  }

  public static text(
    text: string,
    options?: {
      newline?: boolean,
      charset?: string,
    }
  ): Raw {
    const raw = new Raw();
    raw._mode = RawMode.TEXT;
    raw._text = text;
    raw._charset = options?.charset ?? PsdkConst.DEF_CHARSET;
    raw._newline = options?.newline ?? PsdkConst.DEF_ENABLED_NEWLINE;
    return raw;
  }

  public static binary(
    binary: Uint8Array,
    options?: {
      newline?: boolean,
      charset?: string,
    }
  ): Raw {
    const raw = new Raw();
    raw._mode = RawMode.BINARY;
    raw._binary = binary;
    raw._charset = options?.charset ?? PsdkConst.DEF_CHARSET;
    raw._newline = options?.newline ?? PsdkConst.DEF_ENABLED_NEWLINE;
    return raw;
  }

  append(arg: Arg<Uint8Array>): Raw {
    super.append(arg);
    return this;
  }

  prepend(arg: Arg<Uint8Array>): Raw {
    super.prepend(arg);
    return this;
  }

  clause(): CommandClause {
    let clause;
    switch (this._mode) {
      case RawMode.TEXT:
        clause = CommandClause.text(this._text, this._charset);
        break;
      case RawMode.BINARY:
        clause = CommandClause.binary(this._binary);
        break;
      default:
        clause = CommandClause.none();
        break;
    }
    return clause;
  }

  header(): Uint8Array {
    return PsdkConst.EMPTY_BYTES;
  }

  newline(): boolean {
    return this._newline;
  }

}

export enum RawMode {
  BINARY = 'BINARY',
  TEXT = 'TEXT',
}
